import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ExpandableList } from '@bibliocommons/expandable';
import AuthorLink from 'app/components/bibs/shared/AuthorLink';
import { SecondaryLink } from '@bibliocommons/base-links';

import './AuthorsList.scss';

function renderAuthorLink(author, handleClick) {
  return <AuthorLink linkTag={SecondaryLink} authors={Immutable.List.of(author)} handleClick={handleClick} />;
}

export default function AuthorsList({ authors, handleClick }) {
  return (
    <div className="cp-authors-list">
      <ExpandableList
        className="authors-list"
        collapseCount={3}
        expandLinkHref="#show-more-authors"
        getItemKey={author => author}
        itemClassName="author-item"
        list={authors}
        renderItem={author => renderAuthorLink(author, handleClick)}
        stacked
        textKey="authors"
      />
    </div>
  );
}

AuthorsList.propTypes = {
  authors: ImmutablePropTypes.list,
  handleClick: PropTypes.func.isRequired
};
